import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { registerUseridByAmountCurrency, registerUseridByAmount } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "registerUserPayment",
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      deviceList: [{
        label: this.$t('newAccountLabel'),
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user",
        days: 7
      },
      value2: [],
      tableData: [],
      Dynamic: [],
      searchData: {
        kind: 1
      },
      dimenList: [{
        label: this.$t('yes'),
        value: 1
      }, {
        label: this.$t('no'),
        value: 2
      }]
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClickNew: function searchClickNew() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var searchCurrency, reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.timeInterval();

              case 2:
                searchCurrency = _this2.$store.state.d2admin.serchSelect.searchCurrency;
                reqFn = searchCurrency.length ? registerUseridByAmountCurrency : registerUseridByAmount;
                _this2.screen = [];
                _this2.PrimitiveDy = [];
                _this2.searchData = {
                  dimension_kind: _this2.paramsData.dimension_kind,
                  game_id: _this2.searchData.game_id,
                  special_product_id: _this2.searchData.special_product_id,
                  starttime: _this2.searchData.starttime,
                  endtime: _this2.searchData.endtime,
                  server_id: _this2.paramsData.server_id,
                  recharge_levels: _this2.paramsData.recharge_levels,
                  days: _this2.paramsData.days
                };

                _this2.searchClickPoints(reqFn, 1);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(qudata) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var day, allAmount;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.Dynamic = [];

                if (qudata.length) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                for (day = 1; day <= _this3.paramsData.days; day++) {
                  _this3.Dynamic.push({
                    label: _this3.$t('dayN', {
                      n: day
                    }),
                    prop: "day".concat(day)
                  });
                }

                allAmount = {};
                _context2.next = 7;
                return _this3.timeInterval();

              case 7:
                _this3.tableData = [];
                qudata.forEach(function (item) {
                  _this3.tableData.push(_objectSpread({}, item));
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        prop: 'reg_date'
      }, {
        label: this.$t('registerCount'),
        prop: 'new_count'
      }].concat(_toConsumableArray(this.Dynamic));
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};